export default __webpack_public_path__ + "static/social-crimen-tasas_en-2a143c467161eb5ecb1092954d905feb.png";